import {
    AutomobileCollateralDTO,
    PostCollateralsAssetsDTO,
} from 'api/application/types.d'
import AssetDataSource from 'state/enums/AssetDataSource'
import { isLikeInvoice } from 'utils/bookingSourceHelper'
import { NADAAccessory } from 'api/vehicles/postNADAAccessories'
export interface Vehicle {
    condition: string
    year: number
    make: string
    model: string
    trim: string
    vin?: string
    automobileId?: string
    color?: string
    nadaAccessories?: NADAAccessory[]
    invoice?: number
    bookingSource?: string
    mileage?: number | string | null
    wholesale?: number
    likeInvoice?: number
    lendingValue?: number
    isCpo?: boolean
}

function getCollateralAssetValue(vehicle: Vehicle): number {
    let assetValue: number | undefined = 0

    if (vehicle.condition === 'new') assetValue = vehicle.invoice
    else if (!isLikeInvoice(vehicle.year, vehicle.bookingSource))
        assetValue = vehicle.wholesale
    else assetValue = vehicle.lendingValue

    return assetValue ?? 0
}

export function createPostCollateralsAssetsDTO(
    vehicle: Vehicle,
): PostCollateralsAssetsDTO<AutomobileCollateralDTO> {
    const validatedAutomobileId =
        !!vehicle.automobileId && Number.isFinite(Number(vehicle.automobileId))

    const dto: PostCollateralsAssetsDTO<AutomobileCollateralDTO> = {
        collateral: [
            {
                asset: {
                    condition: vehicle.condition === 'new' ? 'N' : 'U',
                    year: vehicle.year,
                    make: vehicle.make,
                    model: vehicle.model,
                    trim: vehicle.trim,
                    automobile_id: validatedAutomobileId
                        ? Number(vehicle.automobileId)
                        : null,
                    invoice_price: vehicle.invoice,
                    booking_source: vehicle.bookingSource,
                    wholesale_price: vehicle.wholesale,
                    like_invoice_price: vehicle.likeInvoice,
                    is_cpo:
                        vehicle.condition === 'used' ? !!vehicle.isCpo : false,
                },
                asset_type: 'automobile',
                asset_value: getCollateralAssetValue(vehicle),
                data_source: validatedAutomobileId
                    ? AssetDataSource.LOS
                    : AssetDataSource.WRITE_IN,
            },
        ],
    }

    // the initial form value for mileage is an empty string
    if (typeof vehicle.mileage === 'number' && vehicle.condition !== 'new') {
        dto.collateral[0].asset.mileage = vehicle.mileage
    }

    if (vehicle.vin) {
        dto.collateral[0].unique_external_id = vehicle.vin
    }

    if (vehicle.nadaAccessories?.length) {
        dto.collateral[0].asset.nada_accessories = vehicle.nadaAccessories
    }

    return dto
}
